import { Controller } from "@hotwired/stimulus"

/**
 * Tech Specs Reveal Controller
 *
 * Reveals product-specs sections (label + content) with a fly-in-from-bottom
 * animation when they enter the viewport, matching the original SpinShot site.
 *
 * Usage: Add data-controller="tech-specs-reveal" to the section that wraps
 * .product-specs-wrapper elements (e.g. .product-specs-sections).
 */
export default class extends Controller {
  connect() {
    this.element.classList.add("tech-specs-reveal")
    this.wrappers = this.element.querySelectorAll(".product-specs-wrapper")
    this.observer = new IntersectionObserver(
      (entries) => this.handleIntersect(entries),
      { rootMargin: "0px 0px -25% 0px", threshold: 0 }
    )
    this.wrappers.forEach((el) => this.observer.observe(el))
  }

  disconnect() {
    this.observer?.disconnect()
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible")
      }
    })
  }
}
